import { Component } from "react";
import trackingService from "../../services/trackingService";
import GMAFTAFilter, {
    GMAF_CONTENT_SUBTYPES,
    GMAF_TA_OPTIONS,
    GMAFContentSubtypeFilter,
    GMAFProductMultiSelect,
    getGMAFBranchKey,
    getGMAFSelectedSubtypePaths,
    getGMAFSubtypeValue,
    getGMAFSubtypeValues,
    getGMAFTALabel,
} from "./GMAFTAFilter";
import "../ContentShortcuts/ContentShortcuts.css";
import "./ContentShortcut.css";

class GMAFGenAIRec extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCSModal: false,
            taExpanded: false,
            selectedTAs: [],
            expandedTAs: {},
            expandedAssetCategories: {},
            selectedAssetCategories: {},
            selectedAssetTypes: {},
            expandedSubtypes: {},
            selectedSubtypes: [],
            selectedProducts: [],
            showTAValidation: false,
            showProductValidation: false,
            showUrlValidation: false,
            GMAFProducts: this.props.GMAFProducts ? this.props.GMAFProducts : [],
        };
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.showGMAFCSModal !== this.state.showCSModal) {
            this.setState({ showCSModal: this.props.showGMAFCSModal });
        }
        if (this.props.GMAFProducts !== prevProps.GMAFProducts) {
            this.setState({ GMAFProducts: this.props.GMAFProducts });
        }
    };

    handleCloseModal = () => {
        this.setState({ showCSModal: false }, () => {
            this.props.handelGMAFCardDetail(this.state.showCSModal);
        });
    };

    handleTAChange = (ta) => {
        this.setState((prev) => {
            const isSelected = prev.selectedTAs.includes(ta);
            const selectedAssetCategories = { ...prev.selectedAssetCategories };
            const selectedAssetTypes = { ...prev.selectedAssetTypes };

            if (isSelected) {
                delete selectedAssetCategories[ta];
                Object.keys(selectedAssetTypes).forEach((key) => {
                    if (key.startsWith(`${ta}::`)) delete selectedAssetTypes[key];
                });
            }

            return {
                selectedTAs: isSelected
                    ? prev.selectedTAs.filter((selectedTA) => selectedTA !== ta)
                    : [...prev.selectedTAs, ta],
                selectedAssetCategories,
                selectedAssetTypes,
                showTAValidation: false,
            };
        });
    };

    handleAllTAsChange = () => {
        this.setState((prev) => {
            const allSelected = GMAF_TA_OPTIONS.every((ta) =>
                prev.selectedTAs.includes(ta.key)
            );
            return {
                selectedTAs: allSelected
                    ? []
                    : GMAF_TA_OPTIONS.map((ta) => ta.key),
                selectedAssetCategories: allSelected
                    ? {}
                    : prev.selectedAssetCategories,
                selectedAssetTypes: allSelected ? {} : prev.selectedAssetTypes,
                showTAValidation: false,
            };
        });
    };

    handleToggleTA = (ta) => {
        this.setState((prev) => ({
            expandedTAs: {
                ...prev.expandedTAs,
                [ta]: !prev.expandedTAs[ta],
            },
        }));
    };

    handleToggleAssetCategory = (ta, categoryKey) => {
        const branchKey = getGMAFBranchKey(ta, categoryKey);
        this.setState((prev) => ({
            expandedAssetCategories: {
                ...prev.expandedAssetCategories,
                [branchKey]: !prev.expandedAssetCategories[branchKey],
            },
        }));
    };

    handleAssetCategoryChange = (ta, categoryKey) => {
        this.setState((prev) => {
            const currentCategories = prev.selectedAssetCategories[ta] || [];
            const isSelected = currentCategories.includes(categoryKey);
            const selectedAssetTypes = { ...prev.selectedAssetTypes };

            if (isSelected) {
                delete selectedAssetTypes[getGMAFBranchKey(ta, categoryKey)];
            }

            return {
                selectedTAs: prev.selectedTAs.includes(ta)
                    ? prev.selectedTAs
                    : [...prev.selectedTAs, ta],
                selectedAssetCategories: {
                    ...prev.selectedAssetCategories,
                    [ta]: isSelected
                        ? currentCategories.filter((key) => key !== categoryKey)
                        : [...currentCategories, categoryKey],
                },
                selectedAssetTypes,
                showTAValidation: false,
            };
        });
    };

    handleAssetTypeChange = (ta, categoryKey, assetType) => {
        const branchKey = getGMAFBranchKey(ta, categoryKey);
        this.setState((prev) => {
            const currentAssetTypes = prev.selectedAssetTypes[branchKey] || [];
            const currentCategories = prev.selectedAssetCategories[ta] || [];
            const isSelected = currentAssetTypes.includes(assetType);

            return {
                selectedTAs: prev.selectedTAs.includes(ta)
                    ? prev.selectedTAs
                    : [...prev.selectedTAs, ta],
                selectedAssetCategories: {
                    ...prev.selectedAssetCategories,
                    [ta]: currentCategories.includes(categoryKey)
                        ? currentCategories
                        : [...currentCategories, categoryKey],
                },
                selectedAssetTypes: {
                    ...prev.selectedAssetTypes,
                    [branchKey]: isSelected
                        ? currentAssetTypes.filter((type) => type !== assetType)
                        : [...currentAssetTypes, assetType],
                },
                showTAValidation: false,
            };
        });
    };

    handlePrimarySubtypeChange = (subtype) => {
        this.setState((prev) => {
            const subtypeValues = getGMAFSubtypeValues(subtype);
            const allSelected = subtypeValues.every((secondary) =>
                prev.selectedSubtypes.includes(secondary)
            );
            return {
                selectedSubtypes: allSelected
                    ? prev.selectedSubtypes.filter(
                        (secondary) => !subtypeValues.includes(secondary)
                    )
                    : [
                        ...prev.selectedSubtypes,
                        ...subtypeValues.filter(
                            (secondary) =>
                                !prev.selectedSubtypes.includes(secondary)
                        ),
                    ],
            };
        });
    };

    handleAllSubtypesChange = () => {
        const allAssetTypes = GMAF_CONTENT_SUBTYPES.flatMap(getGMAFSubtypeValues);
        this.setState((prev) => ({
            selectedSubtypes: allAssetTypes.every((secondary) =>
                prev.selectedSubtypes.includes(secondary)
            )
                ? []
                : [...allAssetTypes],
        }));
    };

    handleSecondarySubtypeChange = (subtype, secondary) => {
        const subtypeValue = getGMAFSubtypeValue(subtype, secondary);
        this.setState((prev) => ({
            selectedSubtypes: prev.selectedSubtypes.includes(subtypeValue)
                ? prev.selectedSubtypes.filter((item) => item !== subtypeValue)
                : [...prev.selectedSubtypes, subtypeValue],
        }));
    };

    handleToggleSubtype = (subtypeKey) => {
        this.setState((prev) => ({
            expandedSubtypes: {
                ...prev.expandedSubtypes,
                [subtypeKey]: !prev.expandedSubtypes[subtypeKey],
            },
        }));
    };

    handleProductChange = (product) => {
        this.setState((prev) => ({
            selectedProducts: prev.selectedProducts.includes(product)
                ? prev.selectedProducts.filter((item) => item !== product)
                : [...prev.selectedProducts, product],
            showProductValidation: false
        }));
    };

    handleApplyFilters = () => {
        const {
            selectedTAs,
            selectedSubtypes,
            selectedProducts,
        } = this.state;
        if (selectedTAs.length === 0) {
            this.setState({ showTAValidation: true });
            return;
        }

        const subtypePaths = getGMAFSelectedSubtypePaths(selectedSubtypes);
        let basePath = "";
        let dt_gmar_basePath = "Document Type/Global Medical Affairs Resources"
        const allTAsSelected = GMAF_TA_OPTIONS.every((ta) =>
            selectedTAs.includes(ta.key)
        );
        const taPaths = allTAsSelected
            ? [dt_gmar_basePath]
            : selectedTAs.map((taKey) => `${taKey}`);
        const allSubtypeValues = GMAF_CONTENT_SUBTYPES.flatMap(
            getGMAFSubtypeValues
        );
        const allSubtypesSelected = allSubtypeValues.every((subtype) =>
            selectedSubtypes.includes(subtype)
        );
        const filters = allSubtypesSelected
            ? taPaths.join(";")
            : subtypePaths.length > 0
                ? selectedTAs.flatMap((taKey) =>
                    subtypePaths.map(
                        (subtypePath) => `${taKey}/${subtypePath}`
                    )
                ).join(";")
                : taPaths.join(";");
        const isGMAFOnly = filters === dt_gmar_basePath;
        const queryParams = new URLSearchParams({
            query: "",
            q: "All Fields",
            filters: '',
        });
        if (isGMAFOnly) {
            queryParams.set("filters", filters.replace(/\u200B/g, ""));
        } else {
            queryParams.set("GMAFfilters", filters.replace(/\u200B/g, ""));
        }

        const numberedFilters = [];

        if (selectedProducts.length > 0) {
            numberedFilters.push(["product", (selectedProducts.join(";"))]);
        }
        // if (isGMAFOnly) {
        //     numberedFilters.push(["domain", "GMAF"]);
        // }

        numberedFilters.forEach(([field, value], index) => {
            const filterNumber = index + 1;
            queryParams.set(`f${filterNumber}`, field);
            queryParams.set(`fval${filterNumber}`, value);
        });
        if (numberedFilters.length > 0) {
            queryParams.set("fcount", numberedFilters.length);
        }

        const url = `/results?${queryParams.toString()}`;
        const fullUrl = `${window.location.origin}${url}`;
        if (fullUrl.length >= 2000) {
            this.setState({ showUrlValidation: true });
            return;
        }

        this.setState({ showUrlValidation: false });
        // const filters = [
        //     ...selectedTAs.map((ta) => `Document Type/Global Medical Affairs Resources​/${ta}`),
        //     ...categoryLabels.map(
        //         (category) => `Asset Type Category/${category}`
        //     ),
        //     ...assetTypes.map(
        //         (assetType) => `Asset Type & Non-Core Asset Type/${assetType}`
        //     ),
        //     ...getGMAFSelectedSubtypePaths(selectedSubtypes).map(
        //         (subtypePath) => `Content Subtype/${subtypePath}`
        //     ),
        //     ...selectedProducts.map((product) => `Product/${product}`),
        // ].join(";");
        // console.log("finalFilters", filters, "selectedProducts", selectedProducts)
        //const url = `/results?query=&q=All%20Fields&filters=${encodeURIComponent(filters)}&f1=product&fval1=${encodeURIComponent(selectedProducts.join(';'))}&fcount=1`;


        window.open(url, "_blank");
        this.trackApply(filters);
    };

    trackApply = (filterStr) => {
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem("companyname"),
            "Applied filters from Global Medical Affairs Resources tile",
            "",
            window.location.href,
            "",
            filterStr
        );
    };

    render() {
        return (
            <div className="GenAI-Recomm-ContentShortcutInnerWapper gmaf-tile-wrapper">
                {this.state.showCSModal && (
                    <>
                        <div
                            className="gen-ai-cs-modalHeader"
                            style={{ justifyContent: "space-between", alignItems: "center" }}
                        >
                            <span className="gmaf-tile-header-title">
                            </span>
                            <div className="gen-ai-cs-popup-cancel-btn popoverAvoidClickOutside" style={{ width: "-50px", height: "-18px" }}>
                                <span
                                    className="popoverAvoidClickOutside"
                                    onClick={this.handleCloseModal}
                                >
                                    <svg
                                        width="18px"
                                        height="18px"
                                        className="popoverAvoidClickOutside"
                                        viewBox="0 0 512 512"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="#000000"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        ></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <g
                                                id="Page-1"
                                                strokeWidth="0.00512"
                                                fill="none"
                                                fillRule="evenodd"
                                            >
                                                <g
                                                    id="work-case"
                                                    fill="#afa7a7"
                                                    transform="translate(91.520000, 91.520000)"
                                                >
                                                    <polygon
                                                        id="Close"
                                                        points="328.96 30.2933333 298.666667 1.42108547e-14 164.48 134.4 30.2933333 1.42108547e-14 1.42108547e-14 30.2933333 134.4 164.48 1.42108547e-14 298.666667 30.2933333 328.96 164.48 194.56 298.666667 328.96 328.96 298.666667 194.56 164.48"
                                                    ></polygon>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                            </div>
                        </div>

                        {/* Apply Filters button — fixed above the scrollable list */}
                        <button
                            className="gmaf-apply-btn popoverAvoidClickOutside"
                            onClick={this.handleApplyFilters}
                        >
                            Apply Filters
                        </button>
                        {this.state.showTAValidation && (
                            <div className="gmaf-validation-message" role="alert">
                                Please select at least one TA.
                            </div>
                        )}
                        {this.state.showProductValidation && (
                            <div className="gmaf-validation-message" role="alert">
                                Please select at least one Product.
                            </div>
                        )}
                        {this.state.showUrlValidation && (
                            <div className="gmaf-validation-message" role="alert">
                                Too many filters selected. Please deselect some filters.
                            </div>
                        )}
                        <div className="modal-body-height-genAI gmaf-tile-body">
                            <GMAFTAFilter
                                {...this.state}
                                onAllTAsChange={this.handleAllTAsChange}
                                onTAChange={this.handleTAChange}
                                onToggleTA={this.handleToggleTA}
                                onAssetCategoryChange={this.handleAssetCategoryChange}
                                onToggleAssetCategory={this.handleToggleAssetCategory}
                                onAssetTypeChange={this.handleAssetTypeChange}
                                onToggleTASection={() =>
                                    this.setState((prev) => ({
                                        taExpanded: !prev.taExpanded,
                                    }))
                                }
                                popoverClassName="popoverAvoidClickOutside"
                            />
                            <GMAFContentSubtypeFilter
                                {...this.state}
                                onAllSubtypesChange={this.handleAllSubtypesChange}
                                onPrimarySubtypeChange={
                                    this.handlePrimarySubtypeChange
                                }
                                onSecondarySubtypeChange={
                                    this.handleSecondarySubtypeChange
                                }
                                onToggleSubtype={this.handleToggleSubtype}
                                popoverClassName="popoverAvoidClickOutside"
                            />
                            <GMAFProductMultiSelect
                                selectedProducts={this.state.selectedProducts}
                                onProductChange={this.handleProductChange}
                                popoverClassName="popoverAvoidClickOutside"
                                GMAFProducts={this.state.GMAFProducts}
                            />
                        </div>
                    </>
                )}
            </div>
        );
    }
}

export default GMAFGenAIRec;
